const CACHE_KEY = 'lang'

export const LANG_KEY = {
  en: 'en-US',
  zh: 'zh-hans',
  tw: 'zh-tw',
}

export const CODE_LANG_KEY = {
  js: 'javascript',
  nodejs: 'nodejs',
  go: 'golang',
  shell: 'shell',
  java: 'java',
  python: 'python',
  vue: 'html',
  csharp: 'csharp',
  php: 'php',
}

export const codeLangConfig = [{
  label: 'Python',
  value: CODE_LANG_KEY.python,
}, {
  label: 'Golang',
  value: CODE_LANG_KEY.go,
}, {
  label: 'Nodejs',
  value: CODE_LANG_KEY.js,
}, {
  label: 'Java',
  value: CODE_LANG_KEY.java,
}, {
  label: 'C#',
  value: CODE_LANG_KEY.csharp,
}, {
  label: 'php',
  value: CODE_LANG_KEY.php,
}, {
  label: 'Shell',
  value: CODE_LANG_KEY.shell,
}]

export const codeLangConfig2 = [{
  label: 'Python',
  value: CODE_LANG_KEY.python,
}, {
  label: 'NodeJS',
  value: CODE_LANG_KEY.nodejs,
}, {
  label: 'Golang',
  value: CODE_LANG_KEY.go,
}, {
  label: 'Java',
  value: CODE_LANG_KEY.java,
}, {
  label: 'C#',
  value: CODE_LANG_KEY.csharp,
}, {
  label: 'php',
  value: CODE_LANG_KEY.php,
},]
export const codeLangConfig3 = [{
  label: 'Python',
  value: CODE_LANG_KEY.python,
}]

export const defaultLangKey = 'en'
// 支持的语言
export const LANGS = [{
  label: 'English',
  value: LANG_KEY.en,
}, {
  label: '繁体中文',
  value: LANG_KEY.tw,
}]

export const getLang = () => {
  return window.localStorage.getItem(CACHE_KEY) || LANG_KEY[defaultLangKey]
}

export const setLang = (lang) => {
  let url = window.location.href
  if (lang == "zh-tw") {
    url = url.replaceAll("/#/zh-cn", "/#/zh-tw")
    url = url.replaceAll("/#/en-us", "/#/zh-tw")
  }
  if (lang == "zh-hans") {
    url = url.replaceAll("/#/zh-tw", "/#/zh-cn")
    url = url.replaceAll("/#/en-us", "/#/zh-cn")
  }
  if (lang == "en-US") {
    url = url.replaceAll("/#/zh-tw", "/#/en-us")
    url = url.replaceAll("/#/zh-cn", "/#/en-us")
  }
  if (url.indexOf("/#/zh-cn/") < 0 && url.indexOf("/#/zh-tw/") < 0 && url.indexOf("/#/en-us/") < 0) {
    const arr = url.split("#")
    if (lang == "zh-tw") {
      url = arr[0] + "#/zh-tw/swapV2/changelog"
    }
    if (lang == "en-hans") {
      url = arr[0] + "#/zh-cn/swapV2/changelog"
    }
    if (lang == "en-US") {
      url = arr[0] + "#/en-us/swapV2/changelog"
    }
  }
  window.location.href = url
  window.location.reload()
  window.localStorage.setItem(CACHE_KEY, lang)
}

export const getLangKeyByLang = (lang) => {
  // alert(lang)
  let key = defaultLangKey
  Object.keys(item => {
    if (LANG_KEY[item] === lang) {
      key = item
    }
  })
  return key
}



// WEBPACK FOOTER //
// ./src/utils/lang.js